import { Pause, Play, Volume2, VolumeX } from "lucide-react"
import { useEffect } from 'react'
import { useAudio } from "../../hooks/useAudio"
import { cn } from '../../lib/utils'
import { LoadingSpinner } from "../LoadingConitainer"
import { Button } from "../ui/button"

type MusicControllerListeners = {
  onPlay: () => void
  onPause: () => void
  onVolumeChange: (volume: number) => void
}

export function MusicController({
  className,
  onVolumeChange,
  onPlay,
  onPause,
  hidden,
  ...props
}: Omit<React.ComponentPropsWithoutRef<"div">, keyof MusicControllerListeners> &
  MusicControllerListeners) {
  const { volume, isPlaying, isPending } = useAudio()

  // useEffect(() => {
  //   if ((_volume ?? 0) === 0) return
  //   const observer = new MutationObserver(function () {
  //     if (document.querySelectorAll(".player-video")?.length) {
  //       onVolumeChange(0)
  //     } else {
  //       onVolumeChange(undefined)
  //     }
  //   });
  //   observer.observe(document.body, { childList: true, subtree: true });
  //   return () => {
  //     observer.disconnect();
  //   };
  // }, [_volume])

  const handlePlayPause = () => {
    if (isPlaying) onPause()
    else onPlay()
  }

  useEffect(() => {
    if (hidden) return
    function handleKeyDown(event: KeyboardEvent) {
      switch (event.code) {
        case 'Space':
          event.stopPropagation()
          handlePlayPause()
          break
      }
    }
    window.addEventListener('keydown', handleKeyDown)
    return () => window.removeEventListener('keydown', handleKeyDown)
  }, [isPlaying, hidden])

  return (
    <div {...props} hidden={hidden} className={cn(className, "transform -translate-x-1/2 w-fit bg-background border border-border rounded-lg shadow-lg p-2 overflow-hidden transition-all duration-300 ease-in-out hover:shadow-2xl")}>
      <div className="flex items-center relative overflow-hidden z-10">
        <div className="flex items-center space-x-1">
          <Button disabled={isPending} variant="ghost" size="icon" className="h-8 w-8 transition-transform duration-200 hover:scale-110" onClick={() => {
            handlePlayPause()
          }}>
            {isPending ? <LoadingSpinner /> : isPlaying ? <Pause className="h-4 w-4" /> : <Play className="h-4 w-4" />}
          </Button>
          <Button variant="ghost" size="icon" className="h-8 w-8 transition-transform duration-200 hover:scale-110" onClick={() => {
            onVolumeChange(volume === 0 ? 1 : 0)
          }}>
            {volume > 0 ? <Volume2 className="h-4 w-4" /> : <VolumeX className="h-4 w-4" />}
          </Button>
        </div>
      </div>
    </div>
  )
}
